import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import FileListSF from '../../../components/superUser/account/util/FileListSF'

const FileListPageUI = ({ context, account, onRefreshClick, accountFileList, onFileClick, fileSubmitted }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_scard' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`}
    centered={!account} account={account} page='files'
  >
    {
      (!account) &&
      <SpinnerComponentUI />
    }
    {
      account &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Files</b></span>
            </div>
          }
          right={<span />}
        />

        <FilesUI context={context} account={account} accountFileList={accountFileList}
          fileSubmitted={fileSubmitted} onFileClick={onFileClick}
          onRefreshClick={onRefreshClick}
        />
        <div className='g_muted g_m_top_100 g_m_left_100'>Files of size less than 1 KB bytes not displayed, temporarily</div>
      </div>
    }
  </SuperUserAccountPageUI>

const FilesUI = ({ context, account, accountFileList, onFileClick, fileSubmitted, onRefreshClick }) =>
  <div>
    {
      accountFileList &&
      <>
        <FileListSF context={context} account={account} accountFileList={accountFileList} onRefreshClick={onRefreshClick}
          fileSubmitted={fileSubmitted} onFileClick={onFileClick}
          title='Underwriting' folder='underwriting'
        />
        <FileListSF context={context} account={account} accountFileList={accountFileList} onRefreshClick={onRefreshClick}
          fileSubmitted={fileSubmitted} onFileClick={onFileClick}
          title='Compliance' folder='compliance'
        />
        <FileListSF context={context} account={account} accountFileList={accountFileList} onRefreshClick={onRefreshClick}
          fileSubmitted={fileSubmitted} onFileClick={onFileClick}
          title='Monitoring' folder='monitoring'
        />
      </>
    }

  </div >


export default FileListPageUI
